import * as tslib_1 from "tslib";
import { OnInit, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as Papa from "papaparse";
import { FileUpload } from "primeng/fileupload";
import { ToasterService } from "src/app/toaster.service";
import { environment } from "src/environments/environment";
import { SubscriptionService } from "../subscription.service";
import { SharedService } from 'src/app/shared/shared.service';
import { LoaderService } from "src/app/loader.service";
import { AlertDialogService } from "src/app/shared/alert-dialog/alert-dialog.service";
import { subscriptionCreateSuccessAlert, subscriptionOperationFailureAlert } from '../subscription.create-alert';
import { MatDialog } from '@angular/material';
import * as moment from "moment";
import Utils from "src/app/utils/utils";
import { AuthService } from 'src/app/auth.service';
import { AuthzAccessHintService } from 'src/app/shared/authz-access-hint/authz-access-hint.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { planTypeFromConfig, applicableConfig } from '../subscription.applicable-types';
var BulkCreateSubscriptionComponent = /** @class */ (function () {
    function BulkCreateSubscriptionComponent(toasterService, subscriptionService, loaderService, alertDialogService, sharedService, dialog, authService, authzAccessHintService) {
        this.toasterService = toasterService;
        this.subscriptionService = subscriptionService;
        this.loaderService = loaderService;
        this.alertDialogService = alertDialogService;
        this.sharedService = sharedService;
        this.dialog = dialog;
        this.authService = authService;
        this.authzAccessHintService = authzAccessHintService;
        this.authzAccessHint = null;
        this.states = [];
        this.cities = [];
        this.modes = [];
        this.categories = [];
        this.services = [];
        this.allServices = [];
        this.configsBySdid = {};
        this.matchedRule = null;
        this.todayDate = new Date();
        this.minDate = this.todayDate;
        this.overlappingRules = [];
        this.Utils = Utils;
        this.subscriptionTypes = ["REGULAR", "CASHBACK"];
        this.hasCashbackPermission = false;
        this.subscriptionConstructFormGroup = new FormGroup({
            selectedType: new FormControl("REGULAR", Validators.required),
            selectedState: new FormControl(null),
            selectedCity: new FormControl(null),
            selectedMode: new FormControl(null),
            selectedCategory: new FormControl(null),
            selectedService: new FormControl(null),
            fromDate: new FormControl(null, Validators.required),
            toDate: new FormControl(null, Validators.required),
        });
    }
    BulkCreateSubscriptionComponent.prototype.formValue = function (name) {
        return this.subscriptionConstructFormGroup.get(name).value;
    };
    BulkCreateSubscriptionComponent.prototype.resetOnchangeOf = function (controlName, toReset, cb) {
        var _this = this;
        if (cb === void 0) { cb = function () { }; }
        this.subscriptionConstructFormGroup.get(controlName).valueChanges.subscribe(function () {
            toReset.forEach(function (control) {
                _this.subscriptionConstructFormGroup.get(control).setValue(null);
            });
            cb();
        });
    };
    Object.defineProperty(BulkCreateSubscriptionComponent.prototype, "taxInfoText", {
        get: function () {
            return this.applicableConfig().exclusiveOfTax === true
                ? 'This amount is exclusive of tax'
                : 'This amount is inclusive of tax';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BulkCreateSubscriptionComponent.prototype, "isCashback", {
        get: function () {
            return this.formValue("selectedType") === "CASHBACK";
        },
        enumerable: true,
        configurable: true
    });
    BulkCreateSubscriptionComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var permissions, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.resetOnchangeOf("selectedType", ["selectedState", "selectedCity", "selectedMode", "selectedCategory", "selectedService"], function () {
                            _this.cities = [];
                            _this.modes = [];
                            _this.categories = [];
                            _this.services = [];
                            _this.allServices = [];
                            _this.matchedRule = null;
                            _this.resetFile();
                        });
                        this.resetOnchangeOf("selectedState", ["selectedCity", "selectedMode", "selectedCategory", "selectedService"], function () {
                            var state = _this.formValue("selectedState");
                            _this.cities = state && state.cities ? state.cities : [];
                            _this.modes = [];
                            _this.categories = [];
                            _this.services = [];
                            _this.allServices = [];
                            _this.matchedRule = null;
                        });
                        this.resetOnchangeOf("selectedCity", ["selectedMode", "selectedCategory", "selectedService"], function () {
                            _this.modes = [];
                            _this.categories = [];
                            _this.services = [];
                            _this.allServices = [];
                            _this.matchedRule = null;
                            _this.fetchModes();
                        });
                        this.resetOnchangeOf("selectedMode", ["selectedCategory", "selectedService"], function () {
                            _this.categories = [];
                            _this.services = [];
                            _this.allServices = [];
                            _this.matchedRule = null;
                            _this.fetchCategoriesAndServices();
                        });
                        this.resetOnchangeOf("selectedCategory", ["selectedService"], function () {
                            _this.matchedRule = null;
                            _this.filterPrepaidServices();
                        });
                        this.resetOnchangeOf("selectedService", [], function () {
                            _this.matchSelectedService();
                        });
                        return [4 /*yield*/, this.authService.getPermissions()];
                    case 1:
                        permissions = _b.sent();
                        this.hasCashbackPermission = permissions.includes('cashback_subscription_create');
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('subscription')];
                    case 2:
                        _a.authzAccessHint = _b.sent();
                        this.loadInitialData();
                        return [2 /*return*/];
                }
            });
        });
    };
    BulkCreateSubscriptionComponent.prototype.loadInitialData = function () {
        var _this = this;
        this.loaderService.openLoading();
        this.sharedService.fetchStatesAndCities().toPromise().then(function (statesRes) {
            _this.states = (statesRes && statesRes.data && statesRes.data.states) || [];
        }).catch(function (err) {
            console.error('Failed to load states or applicable types', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load states.'
            }));
        }).finally(function () { return _this.loaderService.closeLoading(); });
    };
    BulkCreateSubscriptionComponent.prototype.fetchModes = function () {
        var _this = this;
        var city = this.formValue("selectedCity");
        if (!city || this.isCashback) {
            return;
        }
        this.loaderService.openLoading();
        this.sharedService.fetchModes(city.id).toPromise()
            .then(function (res) {
            _this.modes = (res && res.data && res.data.modes) || [];
        })
            .catch(function (err) {
            console.error('Failed to load modes', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load modes for city.'
            }));
        })
            .finally(function () { return _this.loaderService.closeLoading(); });
    };
    BulkCreateSubscriptionComponent.prototype.fetchCategoriesAndServices = function () {
        var _this = this;
        var city = this.formValue("selectedCity");
        var mode = this.formValue("selectedMode");
        if (!city || !mode || this.isCashback) {
            return;
        }
        this.loaderService.openLoading();
        this.sharedService.fetchSubscriptionServiceOptions(city.id, mode.id).toPromise()
            .then(function (res) {
            _this.categories = (res && res.data && res.data.categories) || [];
            _this.allServices = (res && res.data && res.data.services) || [];
        })
            .catch(function (err) {
            console.error('Failed to load categories and services', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load categories for mode.'
            }));
        })
            .finally(function () { return _this.loaderService.closeLoading(); });
    };
    BulkCreateSubscriptionComponent.prototype.filterPrepaidServices = function () {
        var _this = this;
        var city = this.formValue("selectedCity");
        var mode = this.formValue("selectedMode");
        var category = this.formValue("selectedCategory");
        if (!city || !mode || !category) {
            this.services = [];
            this.configsBySdid = {};
            return;
        }
        var categoryServices = this.allServices
            .filter(function (service) { return String(service.categoryId) === String(category.id); });
        var sdids = categoryServices.map(function (service) { return service.serviceDetailId; }).filter(Boolean);
        if (!sdids.length) {
            this.services = [];
            this.configsBySdid = {};
            return;
        }
        this.loaderService.openLoading();
        this.subscriptionService.getApplicableTypes(sdids, mode.id).toPromise()
            .then(function (res) {
            _this.configsBySdid = (res && res.data) || {};
            _this.services = categoryServices
                .filter(function (service) { return planTypeFromConfig(_this.configsBySdid[service.serviceDetailId]) === 'subscription'; })
                .map(function (service) { return Object.assign({}, service, { mode: mode.id }); });
        })
            .catch(function (err) {
            console.error('Failed to load applicable types', err);
            _this.services = [];
            _this.configsBySdid = {};
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load applicable types for services.'
            }));
        })
            .finally(function () { return _this.loaderService.closeLoading(); });
    };
    BulkCreateSubscriptionComponent.prototype.matchSelectedService = function () {
        var service = this.formValue("selectedService");
        if (!service) {
            this.matchedRule = null;
            return;
        }
        var config = this.configsBySdid[service.serviceDetailId];
        this.matchedRule = config ? { applicableType: config } : null;
    };
    BulkCreateSubscriptionComponent.prototype.applicableConfig = function () {
        return applicableConfig(this.matchedRule) || {};
    };
    BulkCreateSubscriptionComponent.prototype.createSubscriptionRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rules, payload, resp, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loaderService.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.buildRules()];
                    case 2:
                        rules = _a.sent();
                        if (!rules) {
                            return [2 /*return*/];
                        }
                        payload = {
                            type: this.formValue("selectedType"),
                            rules: rules,
                        };
                        return [4 /*yield*/, this.subscriptionService.createSubscriptionRules(payload).toPromise()];
                    case 3:
                        resp = _a.sent();
                        this.alertDialogService.open(subscriptionCreateSuccessAlert(resp, { configRequestKind: 'subscription' }));
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        this.alertDialogService.open(subscriptionOperationFailureAlert(error_1));
                        return [3 /*break*/, 6];
                    case 5:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BulkCreateSubscriptionComponent.prototype.checkDuplicatePriority = function (priorityArray) {
        var seenPriorities = new Set();
        for (var _i = 0, priorityArray_1 = priorityArray; _i < priorityArray_1.length; _i++) {
            var priority = priorityArray_1[_i];
            if (seenPriorities.has(priority)) {
                this.showAlertBox({
                    title: "Error",
                    message: "Duplicate priority detected: " + priority,
                });
                return true;
            }
            seenPriorities.add(priority);
        }
        return false;
    };
    BulkCreateSubscriptionComponent.prototype.buildRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var inputRules, rules, _i, inputRules_1, rule, ruleName, ruleAmount, priority, isCashbackType, userSelectors, userSelectorName, periodInDays, excludeIncentiveTypes, ruleTitle, startTime, endTime, ruleType, ruleDetails, city, services, serviceDetails, mode, exclusiveOfTax, validValidityTypes, validityObj, validity, isAutoAssignedToHH, isAutoAssignedToMC, applicable, suspendServicesPostExpiry, ruleConstruct;
            return tslib_1.__generator(this, function (_a) {
                inputRules = this.fileDetails.records;
                rules = [];
                for (_i = 0, inputRules_1 = inputRules; _i < inputRules_1.length; _i++) {
                    rule = inputRules_1[_i];
                    ruleName = rule.ruleName;
                    ruleAmount = rule.ruleAmount;
                    priority = rule.priority;
                    isCashbackType = this.formValue("selectedType") === "CASHBACK";
                    userSelectors = isCashbackType ? [] : [rule.userSelectors];
                    userSelectorName = isCashbackType ? null : rule.userSelectorName;
                    periodInDays = rule.periodInDays;
                    excludeIncentiveTypes = rule.excludeIncentiveTypes ? rule.excludeIncentiveTypes.split(",") : [];
                    ruleTitle = rule.ruleTitle;
                    startTime = moment(this.minDate).unix();
                    endTime = moment(this.maxDate).unix();
                    ruleType = isCashbackType ? "qualityReset" : (rule.ruleType || "zeroCommission");
                    ruleDetails = {
                        variable: "commission",
                        operator: "=",
                        value: 0,
                        type: "flat"
                    };
                    if (isCashbackType) {
                        rule.validityType = "dapr";
                    }
                    city = void 0, services = void 0, serviceDetails = void 0, mode = void 0;
                    if (isCashbackType) {
                        city = rule.cityId;
                        services = String(rule.serviceId).split(",").map(function (s) { return s.trim(); });
                        serviceDetails = String(rule.serviceDetailId).split(",").map(function (s) { return s.trim(); });
                        mode = rule.mode;
                    }
                    else {
                        city = this.formValue("selectedCity").id;
                        services = [this.formValue("selectedService").id];
                        serviceDetails = [this.formValue("selectedService").serviceDetailId];
                        mode = this.formValue("selectedMode").id;
                    }
                    exclusiveOfTax = this.applicableConfig().exclusiveOfTax === true;
                    validValidityTypes = environment.validityTypesEnabled;
                    if (!validValidityTypes.includes(rule.validityType)) {
                        this.alertDialogService.open({
                            title: "Error",
                            message: "Invalid validityType \"" + rule.validityType + "\" for rule \"" + ruleName + "\". Valid types are: " + validValidityTypes.join(", ") + ".",
                        });
                        return [2 /*return*/, null];
                    }
                    validityObj = { type: rule.validityType };
                    if (rule.validityMaxValue != null && rule.validityMaxValue !== '') {
                        validityObj.maxValue = rule.validityMaxValue;
                    }
                    if (rule.validityMinValue != null && rule.validityMinValue !== '') {
                        validityObj.minValue = rule.validityMinValue;
                    }
                    validity = [validityObj];
                    isAutoAssignedToHH = false;
                    isAutoAssignedToMC = false;
                    applicable = this.applicableConfig();
                    if (rule.blockOrdersPostExpiry && !isCashbackType && !applicable.alwaysSuspendServicesPostExpiry && !applicable.allowSuspendServicesPostExpiry) {
                        return [2 /*return*/, this.alertDialogService.open({
                                title: "Error",
                                message: "Blocking plan can only be applied when the applicable rule allows block services"
                            })];
                    }
                    suspendServicesPostExpiry = isCashbackType
                        || applicable.alwaysSuspendServicesPostExpiry === true
                        || (rule.blockOrdersPostExpiry && applicable.allowSuspendServicesPostExpiry === true);
                    ruleConstruct = {
                        ruleName: ruleName,
                        ruleAmount: ruleAmount,
                        priority: priority,
                        userSelectors: userSelectors,
                        userSelectorName: userSelectorName,
                        periodInDays: periodInDays,
                        excludeIncentiveTypes: excludeIncentiveTypes,
                        ruleTitle: ruleTitle,
                        startTime: startTime,
                        endTime: endTime,
                        city: city,
                        services: services,
                        serviceDetails: serviceDetails,
                        mode: mode,
                        exclusiveOfTax: exclusiveOfTax,
                        ruleType: ruleType,
                        rule: [ruleDetails],
                        validity: validity,
                        isAutoAssignedToHH: isAutoAssignedToHH,
                        isAutoAssignedToMC: isAutoAssignedToMC,
                        suspendServicesPostExpiry: suspendServicesPostExpiry,
                    };
                    rules.push(ruleConstruct);
                }
                return [2 /*return*/, rules];
            });
        });
    };
    BulkCreateSubscriptionComponent.prototype.checkForOverlappingRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isCashback, serviceDetailIds, startTime, endTime, priorityArray, rules, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isCashback = this.formValue("selectedType") === "CASHBACK";
                        if (isCashback) {
                            serviceDetailIds = Array.from(new Set(this.fileDetails.records.flatMap(function (r) { return String(r.serviceDetailId).split(",").map(function (s) { return s.trim(); }); })));
                        }
                        else {
                            serviceDetailIds = [this.formValue("selectedService").serviceDetailId];
                        }
                        startTime = moment(this.minDate).unix();
                        endTime = moment(this.maxDate).unix();
                        priorityArray = this.fileDetails.records.map(function (rule) { return rule.priority; });
                        if (this.checkDuplicatePriority(priorityArray)) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.subscriptionService.getSamePriorityRules(serviceDetailIds, startTime, endTime, priorityArray).toPromise()];
                    case 2:
                        rules = _a.sent();
                        if (rules && rules.length > 0) {
                            this.overlappingRules = rules;
                            this.dialog.open(this.OverlappingPriorityRuleAlert);
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                    case 3:
                        error_2 = _a.sent();
                        this.alertDialogService.open({
                            title: "Error",
                            message: JSON.stringify(error_2.message),
                        });
                        return [2 /*return*/, true];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BulkCreateSubscriptionComponent.prototype.getValues = function (name) {
        return this.subscriptionConstructFormGroup.get(name).value;
    };
    BulkCreateSubscriptionComponent.prototype.changeInDate = function () {
        if (this.getValues('fromDate')) {
            this.minDate = this.getValues('fromDate');
        }
        if (this.getValues('toDate')) {
            this.maxDate = this.getValues('toDate');
        }
    };
    BulkCreateSubscriptionComponent.prototype.canConstructBeUploaded = function () {
        if (this.isCashback) {
            return true;
        }
        return this.getValues("selectedState")
            && this.getValues("selectedCity")
            && this.getValues("selectedMode")
            && this.getValues("selectedCategory")
            && this.getValues("selectedService");
    };
    BulkCreateSubscriptionComponent.prototype.resetFile = function () {
        this.fileDetails = null;
    };
    ;
    BulkCreateSubscriptionComponent.prototype.handleFile = function (event) {
        var _this = this;
        var file = event.files[0];
        this.resetFile();
        Papa.parse(file, {
            dynamicTyping: true,
            header: true,
            skipEmptyLines: true,
            transformHeader: function (header) { return header.trim(); },
            transform: function (value) { return value.trim(); },
            complete: function (results) {
                _this.fileDetails = { records: results.data, name: file.name };
            }
        });
    };
    BulkCreateSubscriptionComponent.prototype.submitConstructs = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var overlappingRulesExist;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loaderService.openLoading();
                        return [4 /*yield*/, this.checkForOverlappingRules()];
                    case 1:
                        overlappingRulesExist = _a.sent();
                        if (overlappingRulesExist) {
                            this.loaderService.closeLoading();
                            return [2 /*return*/];
                        }
                        this.createSubscriptionRules()
                            .finally(function () {
                            _this.loaderService.closeLoading();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    BulkCreateSubscriptionComponent.prototype.showAlertBox = function (options, cb) {
        if (cb === void 0) { cb = function () { }; }
        this.alertDialogService.open(options);
        this.alertDialogService.confirmed()
            .subscribe(function (confirmed) { return confirmed && cb(); });
    };
    BulkCreateSubscriptionComponent.prototype.formatDate = function (date) {
        return moment(date).format('YYYY-MM-DD');
    };
    ;
    Object.defineProperty(BulkCreateSubscriptionComponent.prototype, "sampleFileHeaders", {
        get: function () {
            var isCashback = this.formValue("selectedType") === "CASHBACK";
            return isCashback
                ? environment.cashbackSubscriptionRuleCSVHeaders
                : environment.regularSubscriptionRuleCSVHeaders;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BulkCreateSubscriptionComponent.prototype, "sampleFileRow", {
        get: function () {
            var _this = this;
            var isCashback = this.formValue("selectedType") === "CASHBACK";
            var row = isCashback
                ? environment.cashbackSubscriptionRuleSampleRow
                : environment.regularSubscriptionRuleSampleRow;
            return row.map(function (cell) { return _this.formatSampleCell(cell); });
        },
        enumerable: true,
        configurable: true
    });
    BulkCreateSubscriptionComponent.prototype.formatSampleCell = function (value) {
        if (Array.isArray(value)) {
            return value.join(",");
        }
        return String(value);
    };
    BulkCreateSubscriptionComponent.prototype.downloadSampleFile = function () {
        var isCashback = this.formValue("selectedType") === "CASHBACK";
        Utils.downloadCSVFile({
            fields: isCashback ? environment.cashbackSubscriptionRuleCSVHeaders : environment.regularSubscriptionRuleCSVHeaders,
            data: isCashback ? environment.cashbackSubscriptionRuleSampleRow : environment.regularSubscriptionRuleSampleRow,
            fileName: "subscription_rule_construct_sample.csv",
        });
    };
    return BulkCreateSubscriptionComponent;
}());
export { BulkCreateSubscriptionComponent };
